<template>
  <section v-if="!props.hasError" class="home_hero__pending-balance">
    <button :class="buttonClass" @click="redirectToTransactionsPage">
      <div class="home_hero__pending-balance--container">
        <BaseText :color="NebraskaColors.elementAlpha">
          Saldo em conta
        </BaseText>
        <HomeHeroSummaryLoader v-if="props.isLoading" />
        <div v-else class="home_hero__pending-balance--value">
          <BaseText :color="NebraskaColors.elementOverImage">
            {{ props.balance }}
          </BaseText>
          <BaseIcon icon="EA0170" :colors="NebraskaColors.elementOverImage" />
        </div>
      </div>
    </button>
  </section>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router/composables';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseIcon, BaseText } from '@warrenbrasil/nebraska-web';
import * as trackEvents from '../track-events';
import HomeHeroSummaryLoader from './HomeHeroSummaryLoader.vue';
import { computed } from 'vue';

const props = defineProps<{
  isLoading: boolean;
  hasError: boolean;
  balance: string;
}>();

const router = useRouter();

const buttonClass = computed(() => {
  return `home_hero__pending-balance--content${
    props.isLoading ? ' disabled' : ''
  }
  `;
});

function redirectToTransactionsPage() {
  if (!props.isLoading) {
    trackEvents.trackViewMoreTransactionsEvent();
    router.push({ name: 'transactions' });
  }
}
</script>

<style scoped lang="less">
.home_hero {
  position: absolute;
  width: 100vw;

  :deep(.hero__content) {
    padding: 0;
    margin: 0;
  }

  :deep(.max-width) {
    max-width: 100%;
  }

  &__inactive {
    :deep(.hero-content__picture--img) {
      filter: grayscale(100%);
    }
  }

  &__content {
    max-width: 832px;
    margin: 0 auto;
    padding: 0 @size-spacing-x400;
  }

  &__chips {
    margin-bottom: @size-spacing-x500;
    display: flex;
    height: 26px;
    gap: @size-spacing-x300;

    &--context {
      color: @status-brand !important;
      background: @status-brand-background !important;
    }
  }

  &__loader {
    width: 50%;
    margin-bottom: @size-spacing-x1000;
  }

  &__error {
    margin-bottom: @size-spacing-x1000;
  }

  &__heading {
    :deep(p),
    :deep(h1) {
      color: @element-over-image !important;
    }
  }

  &__disclaimer {
    padding: @size-spacing-x500;
    background-color: @background-primary;
    margin: @size-spacing-x600 0 @size-spacing-x1000;
    border-radius: @size-radius-x200;

    &--title {
      margin-bottom: @size-spacing-x150;
    }
  }

  &__buttons {
    margin: @size-spacing-x600 0 @size-spacing-x1000;
    display: flex;
    gap: @size-spacing-x300;
  }

  &__pending-balance {
    width: 100%;
    height: 64px;
    background-color: @divider-opacity;

    &--content {
      width: 100%;
      max-width: 1008px;
      margin: auto;
      display: block;
      height: 100%;
    }

    &--container {
      display: flex;
      justify-content: space-between;
    }

    &--value {
      display: flex;
    }
  }
}

.disabled {
  pointer-events: none;
}
</style>
